import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = {
  class: "chip-text"
};
const _hoisted_3 = ["aria-label", "onClick"];
const _hoisted_4 = ["placeholder", "disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chip-search", {
      focused: $data.focused,
      compact: $props.compact
    }]),
    onClick: _cache[6] || (_cache[6] = (...args) => $options.focusInput && $options.focusInput(...args))
  }, [_cache[7] || (_cache[7] = _createElementVNode("span", {
    class: "chip-search-icon"
  }, [_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2.2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [_createElementVNode("circle", {
    cx: "11",
    cy: "11",
    r: "8"
  }), _createElementVNode("line", {
    x1: "21",
    y1: "21",
    x2: "16.65",
    y2: "16.65"
  })])], -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.modelValue, (chip, index) => {
    return _openBlock(), _createElementBlock("span", {
      key: chip + '-' + index,
      class: "chip",
      title: chip
    }, [_createElementVNode("span", _hoisted_2, _toDisplayString(chip), 1), _createElementVNode("button", {
      type: "button",
      class: "chip-remove",
      "aria-label": 'Remove ' + chip,
      onClick: _withModifiers($event => $options.removeChip(index), ["stop"])
    }, " × ", 8, _hoisted_3)], 8, _hoisted_1);
  }), 128)), _withDirectives(_createElementVNode("input", {
    ref: "input",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.pending = $event),
    type: "text",
    class: "chip-input",
    autocomplete: "off",
    placeholder: $props.modelValue.length ? '' : $props.placeholder,
    disabled: $props.disabled,
    onKeydown: _cache[1] || (_cache[1] = (...args) => $options.onKeydown && $options.onKeydown(...args)),
    onPaste: _cache[2] || (_cache[2] = _withModifiers((...args) => $options.onPaste && $options.onPaste(...args), ["prevent"])),
    onFocus: _cache[3] || (_cache[3] = $event => $data.focused = true),
    onBlur: _cache[4] || (_cache[4] = (...args) => $options.onBlur && $options.onBlur(...args))
  }, null, 40, _hoisted_4), [[_vModelText, $data.pending]]), $props.modelValue.length || $data.pending ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    type: "button",
    class: "chip-clear",
    "aria-label": "Clear search",
    onClick: _cache[5] || (_cache[5] = _withModifiers((...args) => $options.clearAll && $options.clearAll(...args), ["stop"]))
  }, " × ")) : _createCommentVNode("", true)], 2);
}